exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".forgot-form-ui .page-title {\n  text-align: center;\n  padding: 15px 0px 0 0px;\n  font-weight: 800;\n  font-size: 20px; }\n\n.forgot-form-ui .forgot_form {\n  width: 400px;\n  margin: auto;\n  padding-top: 1rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/forgot_password/forgot_password.scss
// module id = 1035
// module chunks = 1